// extracted by mini-css-extract-plugin
export default {"markdown":"JyBcMnOy","mobile":"mobile"};